import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import GraphList from './GraphList';
import SourceGraphs from './SourceGraphs';
import GraphDetail from './GraphDetail';
import GraphObjectPage from './GraphObjectPage';
import './DataGraph.css';

// Route shell for the Data Graph, mounted in the operator console (Advanced Config): the
// per-source list, one source's named data graphs, one graph's explorer (tables, direct /
// indirect links, its manual links, key and hop limit), and for a Salesforce org the per-object
// page (map + fields) its object list opens.
const DataGraph = () => {
  const { path } = useRouteMatch();
  return (
    <div className='p-0'>
      <Container className='h-100' fluid>
        <Row>
          <Col className='p-0'>
            <Switch>
              <Route exact path={`${path}`}>
                <GraphList />
              </Route>
              <Route exact path={`${path}/:dataSourceId`}>
                <SourceGraphs />
              </Route>
              <Route exact path={`${path}/:dataSourceId/graphs/:graphId`}>
                <GraphDetail />
              </Route>
              <Route exact path={`${path}/:dataSourceId/graphs/:graphId/object/:objectName`}>
                <GraphObjectPage />
              </Route>
            </Switch>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default DataGraph;
